<template>
  <section class="product-details-col product-details-downloads">
    <div v-if="files && files[0].path" class="downloads-item">
      <a :href="files[0].path">
        <svg height="22" width="22"><use xlink:href="#iconDownload"></use></svg>
        <span class="downloads-item-title text-uppercase text-m">
          {{files[0].name}}
        </span>
        <small class="downloads-item-size text-xs">
          {{files[0].weight}}
        </small>
      </a>
    </div>
    <div v-if="files && files.length > 1" class="scrollable-container">
      <ul class="downloads-list">
        <li v-for="(file, index) in files.slice(1)"
            :key="'downloads-item-' + index"
            class="downloads-item">
          <a :href="file.path" v-if="file.path" download>
            <svg height="22" width="22"><use xlink:href="#iconDownload"></use></svg>
            <span class="downloads-item-title text-m">
              {{file.name}}
            </span>
            <small class="downloads-item-size text-xs">
              {{file.weight}}
            </small>
          </a>
        </li>
      </ul>
    </div>

  </section>
</template>

<script>
export default {
  name: 'filesDownload',
  props: {
    files: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.scrollable-container {
  height: 100%;
  max-height: 216px;

  @include screen('sm'){
    max-height: 290px;
  }
}
</style>
